import { AppShell } from '@/components/shell/AppShell';
import { AuthGuard } from '@/lib/auth/AuthGuard';
import { parentCommands, parentNav } from '@/lib/nav/parent';
import { ChildProvider } from './child-context';
import { ChildSwitcher } from './ChildSwitcher';

export function ParentLayout() {
  return (
    <AuthGuard audience="parent">
      <ChildProvider>
        <AppShell audience="parent" nav={parentNav} commands={parentCommands} topbarLeading={<ChildSwitcher />} />
      </ChildProvider>
    </AuthGuard>
  );
}
